import { QueryClient } from '@tanstack/react-query';
import { UserDevice } from '../../models/UserDevice';
import { UserNotification, UserNotificationStatusModel } from '../../models/UserNotification';
import { NotificationStatus } from '../enums';
import { get, post, put } from './ApiWrapper';
import useCustomQuery from '../useCustomQuery';
import useCustomMutation from '../useCustomMutation';
import { staleTimeInOneHour } from '../reactQueryCore';

const basePath = 'pushNotification';

export const saveDeviceToken = async (userDevice: UserDevice, signal?: AbortSignal): Promise<void> => {
	return post(`${basePath}/DeviceToken`, userDevice, signal, true, true);
};

export const useUpdateNotificationStatus = (queryClient: QueryClient) => {
	return useCustomMutation({
		hideLoading: true,
		mutationFn: ({
			userNotificationId,
			status
		}: {
			userNotificationId: number;
			status: NotificationStatus;
		}): Promise<void> => {
			const notifications = [{ userNotificationId, status } as UserNotificationStatusModel];
			return put(basePath, notifications);
		},
		onSuccess: async () => {
			await queryClient.invalidateQueries({ queryKey: [basePath] });
		}
	});
};

export const useGetNotifications = (enabled = true) => {
	return useCustomQuery({
		queryKey: [basePath],
		queryFn: (): Promise<UserNotification[]> => get(basePath),
		staleTime: staleTimeInOneHour,
		enabled
	});
};

export const invalidateNotificationQueries = async (queryClient: QueryClient): Promise<void> => {
	await queryClient.invalidateQueries({ queryKey: [basePath] });
};
